module.exports = __webpack_public_path__ + "img/banner-telesalud3.4ec8103d.png";